/**
 * Formats a US phone number for display.
 *
 * Every number in the product is US, so the "+1" country code is noise and is
 * dropped — the same call the chat design makes ("Also sent as SMS to (865) 206
 * 2839"). It is dropped for ALL accepted shapes on purpose: the same number
 * arrives 10-digit from some endpoints and E.164 from others (comm-service), and
 * prefixing only the latter made one number render two different ways.
 *
 * Anything that isn't a recognised US shape is returned untouched, so a genuine
 * international number keeps its "+<country code>".
 *
 * Display only. Callers that need E.164 for an API must normalise separately
 * (see `toE164` in the softphone).
 */
export const formatPhone = (ph: string) => {
  const phone = ph || "";
  // 10 digits: 4155551234
  if (phone.length === 10) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }
  // 11 digits starting with 1: 14155551234
  if (phone.length === 11 && phone.startsWith("1")) {
    return `(${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7)}`;
  }
  // E.164: +14155551234
  if (phone.startsWith("+1") && phone.length === 12) {
    const digits = phone.slice(2);
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  return phone;
};
